import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.toast` (bottom-right transient notification).
const enter = "x16ylgmi-B";
export const styles = {
  container: {
    kVAEAm: "xixxii4",
    krVfgx: "x1xs9kmq",
    kCIrl2: "xgb5jch",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1fwedmp",
    kY2c9j: "x1aciyhk",
    kfzvcC: "x47corl",
    $$css: true
  },
  toast: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kmVPX3: "x1mgz3w",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "x1oezkus",
    kfzvcC: "x67bb7w",
    k7Eaqz: "xlm99nl",
    ks0D6T: "x1j9u4d2",
    kKVMdj: "x1k704xh x1aquc0h",
    k44tkh: "x1kibfj6",
    kyAemX: "x1171e1e",
    $$css: true
  },
  closeBtn: {
    kmuXW: "x2lah0s",
    kzqmXN: "xvy4d1p",
    kZKoxP: "xxk0z11",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    ksu8eU: "xng3xce",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  ico: {
    kzqmXN: "xgd8bvy",
    kZKoxP: "x1fgtraw",
    kaIpWk: "xur7f20",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kmuXW: "x2lah0s",
    $$css: true
  },
  icoSuccess: {
    kWkggS: "x48i0l6",
    kMwMTN: "x1459q0w",
    $$css: true
  },
  icoWarn: {
    kWkggS: "x1qf8r77",
    kMwMTN: "x155pc8g",
    $$css: true
  },
  icoDanger: {
    kWkggS: "x8qqj1s",
    kMwMTN: "x2wi9gy",
    $$css: true
  },
  message: {
    kUk6DE: "x98rzlu",
    kLWn49: "x37zpob",
    $$css: true
  }
};